import Iframe from "./iframe";

export default Iframe;
